
import { useState, useCallback } from "react";
import { logger } from "@/lib/logger";

/**
 * Hook for managing Slack connector state
 */
export const useConnectorState = (aiStaffId: string) => {
  const [webhookUrl, setWebhookUrl] = useState<string>("");
  const [slackToken, setSlackToken] = useState<string>("");
  
  const resetCredentials = useCallback(() => {
    logger.info({
      message: "Resetting Slack credentials",
      context: { aiStaffId }
    });
    
    setWebhookUrl("");
    setSlackToken("");
  }, [aiStaffId]);

  return {
    webhookUrl,
    setWebhookUrl,
    slackToken,
    setSlackToken,
    resetCredentials
  };
};
